import { Component, HostListener, OnDestroy, OnInit } from '@angular/core';
import { TableDataService } from '../common/services/table-data-service';
import { Store } from '@ngrx/store';
import { OPEN_ALL_SECTIONS } from '../store/user';

import * as _ from 'lodash';
import { Subscription } from 'rxjs/Subscription';
import { BsModalRef, BsModalService } from 'ngx-bootstrap';
import { GraphModalComponent } from '../table-components/graph-modal/graph-modal.component';

@Component({
  selector: 'bed-size-categories',
  templateUrl: './bed-size-categories.component.html',
  styleUrls: ['./bed-size-categories.component.css']
})
export class BedSizeCategoriesComponent implements OnInit, OnDestroy {
  // Header with Full Screen Button
  header: string = 'Bed Size Categories';
  subHeader: string;

  // At a Glance Paragraph
  paragraphText: string;

  // Dark Blue Overview Header
  overviewHeaderOpen = true;

  // table data
  table4Overview;
  table4TotalFacilitySection;
  table4HospitalUnitSection;

  // show/hide tables & table controls
  overViewTableOpen = true;
  totalFacilityTableOpen = true;
  hospitalUnitTableOpen = true;
  tableControlsOpen: boolean = true;

  // Bed Size Category
  bedSizes = [
    { id: 0, abbr: '6-24', name: 'Bed Size Category 6-24 (small)' },
    { id: 1, abbr: '25-49', name: 'Bed Size Category 25-49 (small)' },
    { id: 2, abbr: '50-99', name: 'Bed Size Category 50-99 (small)' },
    { id: 3, abbr: '100-199', name: 'Bed Size Category 100-199 (medium)' },
    { id: 4, abbr: '200-299', name: 'Bed Size Category 200-299 (medium)' },
    { id: 5, abbr: '300-399', name: 'Bed Size Category 300-399 (medium)' },
    { id: 6, abbr: '400-499', name: 'Bed Size Category 400-499 (large)' },
    { id: 7, abbr: '500', name: 'Bed Size Category 500 + (large)' }
  ];
  // Bed Size Selected
  bedSizeSelectedObj;

  // Years Displayed
  yearsToDisplay = [
    { abbr: '2013', checked: false },
    { abbr: '2014', checked: false },
    { abbr: '2015', checked: false },
    { abbr: '2016', checked: false },
    { abbr: '2017', checked: false },
    { abbr: '2018', checked: true },
    { abbr: '2019', checked: true },
    { abbr: '2020', checked: true },
    { abbr: '2021', checked: true },
    { abbr: '2022', checked: true },
  ];

  // Current table used to add remove/year
  default_response;

  // For Spinner
  searchProgress = false;

  // Error Fetching Data?
  errorFetching = false;

  // Screen NGRX Store State
  currentUserUIScreen;

  // Subscriptions to remove onDestroy
  subscriptions: Subscription[] = [];

  // download component
  downloads: any;

  // are we mobile
  displayingMobile = false;

  // graph modal
  basicModalRef: BsModalRef;

  constructor(
    private modalService: BsModalService,
    private tableService: TableDataService,
    private store: Store<any>
  ) {
    this.subscriptions.push(
      store.select('currentUser').subscribe(
        currentUser => {
          this.currentUserUIScreen = currentUser;
          this.setTableControlsOpen(currentUser);
        },
        error => {
          console.log(error);
        }
      )
    );
  }
  @HostListener('window:resize', ['$event'])
  onReSize(event) {
    if (event.target.innerWidth <= 990 && !this.displayingMobile) {
      this.filterYearDropDownForMobile();
    }

    if (event.target.innerWidth >= 991 && this.displayingMobile) {
      this.filterYearDropDownForDesktop();
    }
  }

  filterYearDropDownForMobile() {
    let yearsToDisplayMobile = this.yearsToDisplay.map(function(yearObj) {
      if (yearObj.abbr !== '2020' && yearObj.abbr !== '2021') {
        yearObj.checked = false;
      }
      return yearObj;
    });

    this.yearsToDisplay = yearsToDisplayMobile;
    this.displayingMobile = true;
    this.addYearRemoveYear();
  }

  filterYearDropDownForDesktop() {
    let yearsToDisplayMobile = this.yearsToDisplay.map(function(yearObj) {
      if (yearObj.abbr !== '2016') {
        yearObj.checked = true;
      }
      return yearObj;
    });

    this.yearsToDisplay = yearsToDisplayMobile;
    this.displayingMobile = false;
    this.addYearRemoveYear();
  }

  stopYearDropDownFromClosing(e) {
    e.stopPropagation();
    e.stopImmediatePropagation();
  }

  onChangeSelect(e, id) {
    e.preventDefault();
    this.bedSizeSelectedObj = this.bedSizes[id];
    this.getTableData(this.bedSizeSelectedObj.abbr);
  }

  ngOnInit() {
    //Set initial Bed Size Selected to 6-24
    this.bedSizeSelectedObj = this.bedSizes[0];
    this.getTableData(this.bedSizeSelectedObj.abbr);
    this.checkIfMobileScreen();
  }

  checkIfMobileScreen() {
    if (document.documentElement.clientWidth < 990) {
      this.filterYearDropDownForMobile();
    } else {
      this.filterYearDropDownForDesktop();
    }
  }

  ngOnDestroy() {
    this.subscriptions.forEach(subscription => {
      if (typeof subscription.unsubscribe === 'function') {
        subscription.unsubscribe();
      }
    });
  }

  setTableControlsOpen(currentUser) {
    this.tableControlsOpen = currentUser.tableControlsOpen;
  }

  getTableData(value) {
    const searchOpts = {
      tableId: 'bed-size',
      bsc: value,
      startYear: '2018',
      endYear: '2022'
    };

    this.searchProgress = true;
    this.subscriptions.push(
      this.tableService.getSystem(searchOpts).subscribe(
        ({ data }) => {
          this.searchProgress = false;
          this.default_response = data.getTableData;
          this.paragraphText = this.default_response.tableDetails
            .replace(/\>\s+\</g, '><')
            .replace(/(\r\n|\n|\r)/gm, '')
            .trim();
          const htmlArray = this.default_response.tableTitle.split(':');
          this.header = htmlArray[0];
          this.subHeader = htmlArray[1];
          this.downloads = this.default_response.download;
          this.buildTableSections(this.default_response);
          this.errorFetching = false;
        },
        error => {
          console.error('error fetching from graphql', error);
          this.searchProgress = false;
          this.errorFetching = true;
        }
      )
    );
  }

  toggleOverviewHeader() {
    this.overviewHeaderOpen = !this.overviewHeaderOpen;
  }

  toggleOverviewTable() {
    this.overViewTableOpen = !this.overViewTableOpen;
  }

  toggleFacilityTable() {
    this.totalFacilityTableOpen = !this.totalFacilityTableOpen;
  }

  togglehospitalUnitTable() {
    this.hospitalUnitTableOpen = !this.hospitalUnitTableOpen;
  }

  expandAll() {
    this.overviewHeaderOpen = true;
    this.store.dispatch({
      type: OPEN_ALL_SECTIONS,
      payload: {
        allSectionsOpen: true
      }
    });
  }

  collapseAll() {
    this.overviewHeaderOpen = false;
    this.store.dispatch({
      type: OPEN_ALL_SECTIONS,
      payload: {
        allSectionsOpen: false
      }
    });
  }

  buildTableSections(response) {
    this.table4Overview = response.tableData.section[0];
    this.table4TotalFacilitySection = response.tableData.section[1];
    this.table4HospitalUnitSection = response.tableData.section[2];
    this.addYearRemoveYear();
  }

  addYearRemoveYear() {
    if (!_.isEmpty(this.default_response)) {
      let tempTable = _.cloneDeep(this.default_response);
      let newTable4Overview = tempTable.tableData.section[0];
      let newtable4TotalFacilitySection = tempTable.tableData.section[1];
      let newtable4HospitalUnitSection = tempTable.tableData.section[2];

      this.table4Overview = this.filterTableSection(newTable4Overview);
      this.table4TotalFacilitySection = this.filterTableSection(newtable4TotalFacilitySection);
      this.table4HospitalUnitSection = this.filterTableSection(newtable4HospitalUnitSection);
    }
  }

  refresh() {
    window.location.reload();
  }

  customizer(objValue, srcValue, key) {
    if (key === 'cell') {
      return objValue.concat(srcValue);
    }
  }

  mergeYearInTableData(yearToAdd) {
    let myDeep = _.cloneDeep(this.default_response);
    let newObj = _.mergeWith(myDeep, yearToAdd, this.customizer);
    this.default_response = newObj;
    this.buildTableSections(newObj);
  }

  filterTableSection(section) {
    let yearsToRemoveFromTable = this.yearsToDisplay
      .filter(year => year.checked === false)
      .map(year => year.abbr);

    // only the first section has this header
    if (section.row !== null) {
      section.row = section.row.map(function(obj) {
        let newHeaderRowObj = {};
        newHeaderRowObj['label'] = obj.label;
        newHeaderRowObj['cell'] = obj.cell.filter(function(cell) {
          return !_.includes(yearsToRemoveFromTable, cell.year);
        });
        return newHeaderRowObj;
      });
    }
    section.subsection = section.subsection.map(function(obj) {
      let newObj = {};
      newObj['label'] = obj.label;
      newObj['row'] = obj.row.map(function(row) {
        let rowObj = {};
        rowObj['label'] = row.label;
        rowObj['cell'] = row.cell.filter(function(cell) {
          return !_.includes(yearsToRemoveFromTable, cell.year);
        });
        return rowObj;
      });
      return newObj;
    });
    return section;
  }

  openGraph(rowData) {
    // we are mapping two times we use concat all to remove inner array
    let dataForGraph = this.concatAll(
      rowData.row.map(mainObj =>
        mainObj.cell.map(cell => {
          return {
            year: cell.year,
            value: parseFloat(cell.value.replace(/,/g, ''))
          };
        })
      )
    ).reverse();

    this.basicModalRef = this.modalService.show(GraphModalComponent);
    this.basicModalRef.content.title = rowData.row.map(i => i.label)[0];
    this.basicModalRef.content.yLabel = '';
    this.basicModalRef.content.startingY = Math.min(...dataForGraph.map(i => i.value)) * 0.9;

    this.basicModalRef.content.dataForGraph = dataForGraph;
  }

  concatAll(nestedArrs) {
    let results = [];
    nestedArrs.forEach(subArr => subArr.forEach(i => results.push(i)));
    return results;
  }
}



// WEBPACK FOOTER //
// ./src/app/t4-bed-size-categories/bed-size-categories.component.ts